export default __webpack_public_path__ + "1a0eb1d.png";